import { InteractionType, LogLevel } from "@azure/msal-browser";
import type { SecuritySetting } from "./store/types";

// Redirect flow is not supported inside iframes
export const authType: InteractionType =
    window !== window.parent ? InteractionType.Popup : InteractionType.Redirect;

export function buildConfig(backend_config: SecuritySetting) {
    return {
        auth: {
            clientId: backend_config.clientId,
            authority: `https://login.microsoftonline.com/${backend_config.tenantId}`,
            redirectUri: `${window.location.origin}/`,
            navigateToLoginRequestUrl: true,
        },
        cache: {
            cacheLocation: "sessionStorage"
        },
        system: {
            loggerOptions: {
                loggerCallback: console.log,
                logLevel: LogLevel.Error,
                piiLoggingEnabled: false
            }
        }
    };
}
